module.exports = new __parcel__URL__("space_elixir_accelerator_level_2.b081b216.png").toString();